module.exports = __webpack_public_path__ + "img/11-avatar male.61bac695.png";